import React from "react";

type TextAreaProps = {
  label?: string;
  name: string;
  value: string;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  rows?: number;
  infoText?: string;
};

const TextArea: React.FC<TextAreaProps> = ({
  label,
  name,
  value,
  placeholder,
  onChange,
  error,
  required = false,
  disabled = false,
  className = "",
  rows = 4,
  infoText,
}) => {
  return (
    <div className={`custom-input relative ${className}`}>
      {label && (
        <label htmlFor={name} className="custom-input__label">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange as any}
        required={required}
        disabled={disabled}
        className={`custom-input__container ${error ? "border-red-500" : ""}`}
        rows={rows}
      />
      {infoText && <div className="text-[12px] text-gray-500">{infoText}</div>}
      {error && <div className="text-red-500 text-sm mt-1">{error}</div>}
    </div>
  );
};

export default TextArea;
